import React, { FC, PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PageWrapper from "@components/Home/PageWrapper";
import HomePageTitle from "@components/Home/HomePageTitle/HomePageTitle";
import TextIconButton from "@components/TextIconButton";

export interface PortalPageWrapperProps {
  /** Translation key for the page title (e.g. "patientSchedule.title", "games.title") */
  titleKey: string;
  /** When false, back button is hidden. Default true. */
  showBackToPortal?: boolean;
}

const PortalPageWrapper: FC<PropsWithChildren<PortalPageWrapperProps>> = ({
  titleKey,
  showBackToPortal = true,
  children,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/portal");
  };

  return (
    <PageWrapper>
      {showBackToPortal && (
        <Box marginBottom="32px">
          <TextIconButton
            onClick={handleBack}
            text={t("backButton")}
            icon={ArrowBackIcon}
            variant="text"
            iconLeft={true}
          />
        </Box>
      )}
      <HomePageTitle title={t(titleKey)} />
      {children}
    </PageWrapper>
  );
};

export default PortalPageWrapper;
